import React from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const Dashboard = props => {
  return <h1 className="App-header-text">Dashboard</h1>;
};

export default Dashboard;
